/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if ((scroll > 0) && (scroll < 400)) {
      $('.image-holder').addClass('scale-img');
    } else if (scroll > 400) {
      $('.image-holder').removeClass('scale-img');
    }
  });


// Class Selector
var $Texts = document.querySelectorAll(".FadeText");

// Global variables
$delayMultiplier = 0.03;

// Loop all Texts
for($i in $Texts){

    // clear $conext
    $htmlTag = false;
    $content = "";

    for($x in $Texts[$i].innerHTML){

        delay = ($delayMultiplier * $x).toFixed(2);
        char = ($Texts[$i].innerHTML.charAt($x));

        // check if HTML tag opens
        if(char == "<"){
            $htmlTag = true;
        }

        // Check Status of HTML Tag and fill wrapped char into Context    
        if($htmlTag == false){
            $content += "<span style='animation-delay:"+delay+"s'>"+char+"</span>";
        }else{
            $content += char;
        }

        // check if HTML tag closes
        if(char == ">"){
            $htmlTag = false;
        }
    }

    // Change Text into wrapped text
    $Texts[$i].innerHTML = $content;
}   


  

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();